import RecognitionBanner from "./RecognitionBanner";

export default RecognitionBanner;
